// EmailInbox.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/EmailInbox.module.css";

const EmailInbox = ({ setStep }) => {
  // Local state for emails, unread status, and the currently selected email.
  const [emails, setEmails] = useState([]);
  const [unreadEmails, setUnreadEmails] = useState({});
  const [selectedEmail, setSelectedEmail] = useState(null);
  const timeoutsRef = useRef([]);
  
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate an email arriving after 4.5 seconds.
    const miloEmailTimer = setTimeout(() => {
      setEmails((prev) => [
        {
          id: "milo-1",
          sender: "MILO",
          subject: "Are you tired of waiting?",
          preview: "Is this as frustrating as it feels? Let's fix that.",
          body:
            "With MILO, you'd already be moving in. Want a better way? <strong>Join the waitlist now!</strong>",
          cta: "Join the Waitlist",
        },
        ...prev,
      ]);
      setUnreadEmails((prev) => ({ ...prev, "milo-1": true }));
    }, 4500);

    // Simulate another email arriving after 10 seconds.
    const rejectionEmailTimer = setTimeout(() => {
      setEmails((prev) => [
        {
          id: "landlord",
          sender: "Landlord",
          subject: "About that unit...",
          preview: "Follow up to your inquiry",
          body:
            "Unfortunately this unit has already been filled. We found a great tenant through MILO and the apartment filled way quicker than we had thought.",
          cta: "Join the Waitlist",
        },
        ...prev,
      ]);
      setUnreadEmails((prev) => ({ ...prev, landlord: true }));
    }, 10000);

    timeoutsRef.current.push(miloEmailTimer, rejectionEmailTimer);

    return () => {
      timeoutsRef.current.forEach((timer) => clearTimeout(timer));
      timeoutsRef.current = [];
    };
  }, []);

  // When an email item is clicked, mark it as read and show its details.
  const handleEmailClick = (email) => {
    setSelectedEmail(email);
    setUnreadEmails((prev) => ({ ...prev, [email.id]: false }));
  };

  return (
    <div className={styles.inboxContainer}>
      {!selectedEmail ? (
        <>
          <h3>📬 Inbox</h3>
          <div className={styles.emailList}>
            {emails.length === 0 ? (
              <p className={styles.emptyInbox}>(No new messages yet)</p>
            ) : (
              emails.map((email) => (
                <div
                  key={email.id}
                  className={`${styles.emailItem} ${
                    unreadEmails[email.id] ? styles.unread : ""
                  }`}
                  onClick={() => handleEmailClick(email)}
                >
                  <div className={styles.emailHeader}>
                    <span className={styles.emailFrom}>
                      From: {email.sender}
                    </span>
                    <span className={styles.emailSubject}>
                      {unreadEmails[email.id] && (
                        <span className={styles.unreadDot}></span>
                      )}
                      {email.subject}
                    </span>
                  </div>
                  <div className={styles.emailPreview}>{email.preview}</div>
                </div>
              ))
            )}
          </div>
        </>
      ) : (
        // Display full email details when one is selected.
        <div className={styles.emailView}>
          <div className={styles.emailHeader}>
            <div className={styles.emailFrom}>
              <strong>From:</strong> {selectedEmail.sender}
            </div>
            <div className={styles.emailSubject}>
              <strong>Subject:</strong> {selectedEmail.subject}
            </div>
          </div>
          <div className={styles.emailBody}>
            <p
              dangerouslySetInnerHTML={{ __html: selectedEmail.body }}
            ></p>
            {selectedEmail.cta && (
              <button
                className={styles.ctaButton}
                onClick={() => {
                  // Advance to the next step and clear the selected email.
				  navigate("/waitlist");
                  setStep(1);
                  setSelectedEmail(null);
				  
                }}
              >
                {selectedEmail.cta}
              </button>
            )}
          </div>
          <button
            className={styles.closeEmail}
            onClick={() => setSelectedEmail(null)}
          >
            ❌ Close
          </button>
        </div>
      )}
    </div>
  );
};

export default EmailInbox;
